<template>
  <div>
    <div class="img-box" v-if="status">
      <!-- <slot></slot> -->
      <img v-if="imgStatus" @click.prevent="openDesc" :src="banner" :onerror="imgError" class="banner mb15">
      <div @click="status = !status" class="close ">
        <img src="@/assets/img/icon65.png" alt="" srcset="">
      </div>
    </div>
    <div class="open" @click="status = !status" v-else>
      <div class="open_item mb15">
        <img src="@/assets/img/icon66.png" alt="" srcset="">
      </div>
    </div>
  </div>
  <van-popup v-model:show="showBottom" :style="{ padding: '10px' }">
    <div class="popup_box" v-if="popupStatus">
      <van-button block v-for="item,index in list" :key="index" @click="openPopup(index)" type="primary">{{item.title}}</van-button>
    </div>
    <div class="popup_box" v-else>
      <img :src="info" alt="">
    </div>
  </van-popup>

</template>

<script setup>
import ajax from '../utils/request'
import { ref, defineProps } from 'vue'
const status = ref(true)
const showBottom = ref(false)
const props = defineProps({
  imgStatus: {
    type: Boolean,
    default: true
  },
  banner: {
    type: String,
    require: true
  },
  title: {
    type: String,
    require: true
  }
})
const list = ref([])
const info = ref('')
const popupStatus = ref(true)
const openDesc = () => {
  ajax.post('api/getsettingdetail', { cate_name: props.title }).then(res => {
    if (res.data.length > 0) {
      showBottom.value = true
      popupStatus.value = true
      list.value = res.data
    }
    return

  })
}
const openPopup = (val) => {
  info.value = list.value[val].image
  popupStatus.value = false

}

</script>

<style>
.popup_box{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 200px;
  min-height: 200px;
}
.img-box{
  position: relative;
  
}
.img-box .close{
    position: absolute;
    bottom: 15px;
    right: 0;
    width: 15px;
    height: 15px;
    margin-right: 5px;
    text-align: center;
    line-height: 15px;
    /* background-color: rgba(255, 255, 255, 0.7); */
}
.open{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  
}
.open .open_item{
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
</style>